// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1cVY2","container":"styles_container__3Kgav","title":"styles_title__wltta","wrapper":"styles_wrapper__1O-Cg","answer":"styles_answer__nlWuc"};